<template lang="pug">
div
  .d-flex.fd-column.flex-1(v-if="isLoading")
    div(v-if="modoLista")
      div(v-for="a in 5")
        v-skeleton-loader(type='list-item-avatar-two-line')
        v-skeleton-loader(type='divider')
    div(v-else)
      v-skeleton-loader(type='list-item-avatar-two-line')
  div(v-else)
    v-list.pa-0(dense, nav v-if="modoLista")
      v-list-item-group( v-model="seleccionado"  active-class="primary--text" mandatory  @change="seleccionarUsuario")
        template(v-for="(e, index) in lista")
          v-list-item( :key="index", :value="e")
            template(v-slot:default="{ active }")
              v-list-item-avatar
                img(:src="e.foto ? e.foto : '/static/nobody.jpg'" )
              v-list-item-content
                v-list-item-title
                  span.font-weight-700 {{e.nombre}}
                v-list-item-subtitle
                  span.font-size-11 {{e.cargo}}
    v-autocomplete(
      v-else,
      v-model='seleccionado'
      :items='lista'
      :loading='isLoading'
      :disabled="isLoading"
      item-text='usuario'
      :label="multiple ? 'Selecciona varias opciones' : 'Selecciona una opcion'"
      placeholder='Ingrese un nombre para buscar'
      return-object='',
      dense,
      chips
      :solo="noSolo",
      hide-details,
      :multiple="multiple",
      @change="seleccionarUsuario"
    )
      template(v-slot:selection='data')
        v-chip.pa-4.ma-1(
          color="background"
          close
          v-bind='data.attrs'
          :input-value='data.selected'
          @click.stop='data.select, showModal(data.item)'
          @click:close="remove(data.item)"
        )
          v-avatar(left='')
            v-img(:src="data.item.foto ? data.item.foto : '/static/nobody.jpg'")
          .d-flex.fd-column.line-height-title
            span.font-weight-700 {{ data.item.nombre }}
            small.blue--text.font-size-11 {{ data.item.perfil }}
      template(v-slot:item='data')
        v-list-item-avatar
          img(:src="data.item.foto ? data.item.foto : '/static/nobody.jpg'")
        v-list-item-content
          v-list-item-title.font-size-12.font-weight-700(v-html='data.item.nombre')
          v-list-item-subtitle
            .d-flex
              span.font-size-12 {{data.item.usuario}}
              span.font-size-11.ml-3.primary--text ({{data.item.perfil}})
        v-list-item-action(v-if="data.item.rutaSctr")
          v-btn(fab color="white primary--text" @click.stop='verPdfSctr(data.item.rutaSctr)')
            v-icon picture_as_pdf
    v-dialog(v-model='menu' bottom='' width="400" right='' transition='scale-transition' origin='top left')
      v-card(dense)
        v-img(:src="usuarioDetalles.foto ? usuarioDetalles.foto : '/static/nobody.jpg'", contain, max-height="400")
        v-list(color="primary" dark dense)
          v-list-item
            v-list-item-content
              v-list-item-title {{usuarioDetalles.nombre}}
              v-list-item-subtitle {{usuarioDetalles.usuario}} - {{usuarioDetalles.cargo}}
            v-list-item-action(v-if="usuarioDetalles.rutaSctr")
              v-btn(fab color="white primary--text" @click='verPdfSctr()')
                v-icon picture_as_pdf
          v-list-item(v-if="showChangeFoto")
            v-list-item-content
              v-btn(:small="!isMovil" block color="white primary--text" @click='seleccionarFotoPerfil()')
                | Cambiar foto de perfil
</template>
<script>
import { notify, apiGet } from '../util/general'

export default {
  name: 'c_usuarios_lista_seleccionar',
  props: {
    showChangeFoto: {
      type: Boolean,
      default: false
    },
    noSolo: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    modoLista: {
      type: Boolean,
      default: false
    },
    username: {
      type: String,
      default: ''
    },
    codigoTecnico: {
      type: Number,
      default: 0
    },
    perfiles: {
      type: Array
    }
  },
  data () {
    return {
      isLoading: false,
      lista: [],
      seleccionado: this.multiple ? [] : {},
      menu: false,
      usuarioDetalles: {}
    }
  },
  created () {
    this.fetch()
  },
  computed: {
    isMovil () {
      return this.$vuetify.breakpoint.smAndDown
    }
  },
  methods: {
    seleccionarFotoPerfil () {
      this.$emit('user-change-perfil', this.usuarioDetalles)
    },
    verPdfSctr (rutaSctr) {
      const src = rutaSctr || this.usuarioDetalles.rutaSctr
      if (src) window.open(src, '_blank')
    },
    showModal (item) {
      this.usuarioDetalles = item
      this.menu = true
    },
    remove (item) {
      if (this.multiple) {
        const index = this.seleccionado.findIndex(e => e.codigoTecnico === item.codigoTecnico)
        if (index >= 0) this.seleccionado.splice(index, 1)
      } else {
        this.seleccionado = {}
      }
      this.$emit('user-delete', item)
    },
    removeAll () {
      this.seleccionado = this.multiple ? [] : {}
    },
    seleccionarUsuario (usuario) {
      if (this.modoLista) {
        this.seleccionado = usuario
      }
      this.$emit('user-selected', this.seleccionado)
    },
    fetch () {
      this.isLoading = true
      const obj = {
        perfiles: this.perfiles || []
      }

      apiGet(this, '/usuario/obtener', obj, data => {
        this.lista = data.lista || []

        // Buscar por código técnico
        if (this.codigoTecnico !== 0) {
          const objUsuario = this.lista.find(e => e.codigoTecnico === this.codigoTecnico)
          if (objUsuario) {
            if (this.multiple) this.seleccionado.push(objUsuario)
            else this.seleccionado = objUsuario
            this.seleccionarUsuario(this.seleccionado)
          }
        }

        // Buscar por username (múltiple o único)
        if (this.username) {
          const usernames = this.multiple
            ? this.username.split(',').map(u => u.trim()).filter(Boolean)
            : [this.username.trim()]

          const encontrados = this.lista.filter(e => usernames.includes(e.usuario))

          if (this.multiple) {
            this.seleccionado.push(...encontrados)
          } else if (encontrados.length > 0) {
            this.seleccionado = encontrados[0]
          }

          this.seleccionarUsuario(this.seleccionado)
        }
      }, error => {
        notify(this, 'error', 'Error', error.message)
      }, () => {
        this.isLoading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// c_usuarios_lista_seleccionar.vue?f6835170